import { createSlice } from '@reduxjs/toolkit';

const shiftTemplatesSlice = createSlice({
  name: 'shiftTemplates',
  initialState: {
    templates: [],
    loading: false,
    error: null,
  },
  reducers: {
    setTemplates: (state, action) => {
      state.templates = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setTemplates, setLoading, setError } = shiftTemplatesSlice.actions;
export default shiftTemplatesSlice.reducer; 